const $inject = ['$http', '$q', '$filter'];

const changeCartService = function changeCartService($http, $q, $filter) {
  const service = {
    canContinue: false,
    changeFees: [],
    items: [],
    totals: {
      difference: 0,
      changeFee: 0,
      serviceFee: 0,
      total: 0
    },
    addChange,
    addFlightsForChange,
    remove,
    getChangeFees
  };

  function calculateTotals() {
    const feeTotals = {
      difference: difference(),
      changeFee: changeFee(),
      serviceFee: serviceFee()
    };

    const total = Object.values(feeTotals).reduce((accumulatedTotal, feeTotal) => {
      return accumulatedTotal + feeTotal;
    });

    return {
      difference: $filter('priceWithOperatorFilter')(feeTotals.difference, 2),
      changeFee: $filter('currency')(feeTotals.changeFee, '', 2),
      serviceFee: $filter('currency')(feeTotals.serviceFee, '', 2),
      total: $filter('currency')(total, '', 2)
    };
  }

  function difference() {
    let amount = 0;

    service.items.forEach((item) => {
      if(item.fare) {
        amount += item.fare.CostOfChange;
      }
    });

    return amount;
  }

  function changeFee() {
    let ticketNumbers = new Map();
    let fee = 0;
    
    service.items.forEach((cartItem) => {
      const newFareIsAdded = cartItem.fare && cartItem.result;

      if(newFareIsAdded) {
        const cartItemTicketNumber = cartItem.fare.TicketNumber;
        let existingTicket = ticketNumbers.get(cartItemTicketNumber);
        
        if(existingTicket) {       
          if(existingTicket.ChangeFee <= cartItem.fare.ChangeFee){
            fee -= existingTicket.ChangeFee;
            fee += cartItem.fare.ChangeFee;
            ticketNumbers.set(cartItemTicketNumber, cartItem.fare);
          }
        }
        else {
          fee += cartItem.fare.ChangeFee;          
          ticketNumbers.set(cartItemTicketNumber, cartItem.fare);
        }
        
      }
    });

    return fee;
  }

  function serviceFee() {
    let ticketNumbers = [];
    let fee = 0;

    service.items.forEach((cartItem) => {
      const newFareIsAdded = cartItem.fare && cartItem.result;

      if(newFareIsAdded) {
        const cartItemTicketNumber = cartItem.fare.TicketNumber;

        if(!ticketNumbers.includes(cartItemTicketNumber)) {
          ticketNumbers.push(cartItemTicketNumber);

          service.changeFees.forEach((changeFee) => {
            if(changeFee.Type === 'AgencyChangeFee' && changeFee.TicketNumbers.includes(cartItemTicketNumber)) {
              fee += changeFee.Amount;
            }
          });
        }
      }
    });

    return fee;
  }

  function addChange(index, result, fare) {
    service.items[index].result = result;
    service.items[index].fare = fare;
    service.totals = calculateTotals();
    service.canContinue = canContinue();
  }

  function addFlightsForChange(flights, searches) {
    const cartItems = [];

    const flightsWithSearch = flights.filter((flight) => {
      return searches.some((search) => {
        return search.ParentIdentifier === flight.Identifier;
      });
    });

    flightsWithSearch.forEach((flight, flightIndex) => {
      cartItems.push({
        result: undefined,
        fare: undefined,
        orderBy: flightIndex,
        flight
      });
    });

    service.items = [...cartItems];
    service.totals = calculateTotals();
    service.canContinue = canContinue();
  }

  function remove(orderBy) {
    const deferred = $q.defer();

    const itemToRemoveChange = service.items.find((item) => {
      return item.orderBy === orderBy;
    });

    itemToRemoveChange.result = undefined;
    itemToRemoveChange.fare = undefined;
    service.totals = calculateTotals();
    service.canContinue = canContinue();

    deferred.resolve(itemToRemoveChange);

    return deferred.promise;
  }

  function getChangeFees(itineraryId, passengerId) {
    const apiConfig = window.svelteStore.apiConfig('itineraryPassengerChangeFees', {
      itineraryId,
      passengerId
    });

    $http.get(apiConfig.url, {
      apiVersion: apiConfig.version
    })
    .then((response) => {
      service.changeFees = response.data;
    });
  }

  function canContinue() {
    return service.items.every((cartItem) => {
      return cartItem.result && cartItem.fare;
    });
  }

  return service;
};

changeCartService.$inject = $inject;

export default changeCartService;



// WEBPACK FOOTER //
// ./src/services/changeCartService.js